import React from 'react';
import useRewardsStore from 'graph/state/query-hooks/use-rewards-store';
import Sticker from './Sticker';
import WithQuery from 'components/layout/WithQuery';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate, useParams } from 'react-router-dom';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { STICKER_INDEXES } from 'types';
import { FONT_BILLY_BOLD } from '@monorepo/shared/src/themes/studentAppTheme';

const t = (key: string, options?) => translate('rewards', key, options);

const Stickers: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { character } = useParams();
  const [{ charactersRewards, loading, error }, { handleUpdateSelectedReward }] = useRewardsStore();

  const characterRewards = charactersRewards.find(
    (reward) => reward?.character.character === character
  );
  const invalidData = !loading && !characterRewards?.studentRewards.length;

  if (invalidData) {
    navigate(-1);
    return <></>;
  }

  const handleOnStickerClick = async (id: number | undefined) => {
    if (!id) return;
    handleUpdateSelectedReward(id);
    navigate(-1);
  };

  return (
    <WithQuery error={error}>
      <Box className={classes.container}>
        <Typography component="h1" className={classes.title}>
          {t('pickASticker')}
        </Typography>
        <Typography component="summary" className={classes.subtitle}>
          {t('chooseYourFavorite')}
        </Typography>
        <Box className={classes.grid}>
          {STICKER_INDEXES.map((stickerIndex) => (
            <Sticker
              key={stickerIndex}
              studentReward={characterRewards?.studentRewards?.[stickerIndex]}
              handleOnClick={(id) => handleOnStickerClick(id)}
            />
          ))}
        </Box>
      </Box>
    </WithQuery>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontFamily: FONT_BILLY_BOLD,
    fontSize: theme.typography.pxToRem(120),
    lineHeight: theme.typography.pxToRem(142),
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: FONT_GSS_FUTURA_BOLD,
    fontSize: theme.typography.pxToRem(48),
    lineHeight: theme.typography.pxToRem(73),
    textAlign: 'center',
  },
  grid: {
    display: 'flex',
    justifyContent: 'center',
    gridGap: remCalc(56),
    marginTop: remCalc(48),
    //TODO: Define app breakpoints
    [theme.breakpoints.down(800)]: {
      flexDirection: 'column',
    },
  },
}));

export default Stickers;
